<div class="page">
    <div class="page-header">
        <div class="header unselectable">
            <div class="subheader">
                <a  [routerLink]="['/', 'chat-history']">
                    <img src="assets/images/noun-menu-1166839 1.svg" alt="chat history"
                        class="history" title="Chat history">
                </a>
                <a [routerLink]="['/', 'home', 'voice']">
                    <span class="title">
                        <img src="assets/images/Logo_HAL.png" alt="logo" class="logo"
                            >
                        <!-- HAL -->
                    </span>
                </a>
            </div>
            <div class="subheader buttons">
                <div class="image-container">
                    <img src="assets/images/noun-chat-5153456 1.svg" alt="new-conversation" class="new-conversation"
                        (click)="startNewConversation()" title="Start new conversation">
                </div>
                <div class="dropdown image-container">
                    <img src="assets/images/noun-burger-7249294 1.svg" id="header-menu" alt="menu" class="menu"
                        (click)="isHeaderMenuOpen = !isHeaderMenuOpen">
                    @if(isHeaderMenuOpen) {
                        <ul class="dropdown-panel" id="header-dropdown-panel">
                            <li (click)="$event.stopPropagation(); logout()" (touchstart)="$event.stopPropagation(); logout()">
                                Log&nbsp;out
                            </li>
                        </ul>
                    }
                </div>
            </div>
        </div>
        <div class="navbar unselectable">
            <a [routerLink]="['/', 'home', 'voice']" routerLinkActive="active">Voice</a>
            <!-- <a [routerLink]="['/', 'home', 'chat']" routerLinkActive="active">Text</a> -->
            <a [routerLink]="['/', 'home', 'shortcuts']" routerLinkActive="active">Shortcuts</a>
        </div>
    </div>
    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>
